import { CatLoadingIndicator } from 'components/blocks-components';
import styles from '../multi-modal-loaders.module.scss';
const MultiModalPageLoader = () => {
  return (
    <div
      className={`${styles['loader-container']} d-flex justify-content-center align-items-center w-100 h-100 position-fixed top-0 left-0 overflow-hidden`}
    >
      <CatLoadingIndicator />
    </div>
  );
};
export default MultiModalPageLoader;
